import Enumerator from './Enumerator';

export const vehicleTypes = [
  'none',
  'car',
  'motorcycle',
  'watercraft',
  'bicycle',
  'light_commercial',
  'trailer',
  'truck',
  'bus_coach_or_special_purpose',
  'caravan',
  'locomotive',
  'rail_cars',
  'other'
];

export class VehicleType extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
        correctOption = 'bicycle';
        break;
      case '2':
      case '9':
        correctOption = 'other';
        break;
      case '3':
        correctOption = 'bus_coach_or_special_purpose';
        break;
      case '4':
        correctOption = 'car';
        break;
      case '5':
        correctOption = 'caravan';
        break;
      case '6':
        correctOption = 'light_commercial';
        break;
      case '7':
        correctOption = 'locomotive';
        break;
      case '8':
        correctOption = 'motorcycle';
        break;
      case '10':
        correctOption = 'rail_cars';
        break;
      case '11':
        correctOption = 'trailer';
        break;
      case '12':
        correctOption = 'truck';
        break;
      case '13':
        correctOption = 'watercraft';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

VehicleType.initEnum({
  none: {
    get title() {
      return 'Select one';
    }
  },
  car: {
    get title() {
      return 'Car';
    }
  },
  motorcycle: {
    get title() {
      return 'Motorcycle';
    }
  },
  watercraft: {
    get title() {
      return 'Watercraft';
    }
  },
  bicycle: {
    get title() {
      return 'Bicycle';
    }
  },
  light_commercial: {
    get title() {
      return 'Light commercial';
    }
  },
  trailer: {
    get title() {
      return 'Trailer';
    }
  },
  truck: {
    get title() {
      return 'Truck';
    }
  },
  bus_coach_or_special_purpose: {
    get title() {
      return 'Bus coach or special purpose';
    }
  },
  caravan: {
    get title() {
      return 'Caravan';
    }
  },
  locomotive: {
    get title() {
      return 'Locomotive';
    }
  },
  rail_cars: {
    get title() {
      return 'Rail cars';
    }
  },
  other: {
    get title() {
      return 'Other';
    }
  }
});

export default {
  vehicleTypes,
  VehicleType
};
